__turbopack_context__.v({
  "body": "FolderPickerModal-module__C_q_fW__body",
  "chevronSpacer": "FolderPickerModal-module__C_q_fW__chevronSpacer",
  "createButton": "FolderPickerModal-module__C_q_fW__createButton",
  "description": "FolderPickerModal-module__C_q_fW__description",
  "errorText": "FolderPickerModal-module__C_q_fW__errorText",
  "folderCheck": "FolderPickerModal-module__C_q_fW__folderCheck",
  "folderFilterRow": "FolderPickerModal-module__C_q_fW__folderFilterRow",
  "folderIcon": "FolderPickerModal-module__C_q_fW__folderIcon",
  "folderIconSelected": "FolderPickerModal-module__C_q_fW__folderIconSelected",
  "folderName": "FolderPickerModal-module__C_q_fW__folderName",
  "folderRow": "FolderPickerModal-module__C_q_fW__folderRow",
  "folderRowDisabled": "FolderPickerModal-module__C_q_fW__folderRowDisabled",
  "folderRowSelected": "FolderPickerModal-module__C_q_fW__folderRowSelected",
  "footer": "FolderPickerModal-module__C_q_fW__footer",
  "footerActions": "FolderPickerModal-module__C_q_fW__footerActions",
  "loadingContainer": "FolderPickerModal-module__C_q_fW__loadingContainer",
  "newFolderInput": "FolderPickerModal-module__C_q_fW__newFolderInput",
  "topLevelCheckboxRow": "FolderPickerModal-module__C_q_fW__topLevelCheckboxRow",
  "trashButton": "FolderPickerModal-module__C_q_fW__trashButton",
  "treeList": "FolderPickerModal-module__C_q_fW__treeList",
});
